import { render, staticRenderFns } from "./OrganizationViewOrganizationTeamsCard.vue?vue&type=template&id=4bc12a7c"
import script from "./OrganizationViewOrganizationTeamsCard.vue?vue&type=script&lang=js"
export * from "./OrganizationViewOrganizationTeamsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports